import { render, staticRenderFns } from "./SalarieSearch.vue?vue&type=template&id=08fba3ca&scoped=true"
import script from "./SalarieSearch.vue?vue&type=script&lang=js"
export * from "./SalarieSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fba3ca",
  null
  
)

export default component.exports